const entityTypes = {
	USER: {
		type: 'USER'
	},
	KIT: {
		type: 'KIT'
	},
	ITEM: {
		type: 'ITEM'
	},
	POST: {
		type: 'POST'
	}
}

export default entityTypes



// WEBPACK FOOTER //
// ./src/enums/entityTypes.js